





































































import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../mixins';
import { TrackingService } from '../api';
import { CompletePoint, Geofence, GeofenceAdd, Point, PointsOfInterest, Polygon, PolygonComplete } from '../models';
import { isProductionMode, ElementId, hasElements, getIndexFromList, isNumber } from '../utils';
import Combobox from './Combobox.vue';

@Component({
    components: {
        Combobox
    }
})
export default class AddPolygon extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: false }) editing: boolean;
    @Prop({ default: false }) showCropType: boolean;
    @Prop({ default: 'Modificar ' }) modalTitle: string;
    @Prop({ default: null }) featureToEdit: google.maps.Data.Feature | null;
    cropTypeOptions: Array<object> = [];
    loading: boolean = false;
    name: string = '';
    harvestType: object | null = null;
    cropTypeSelected: any = null;
    cropTypeRV: boolean = false;

    @Emit()
    clickAddNewPolygon() {}

    @Emit()
    modifyRanchPolygon(name: string, cropTypeSelected: object | null, feature:google.maps.Data.Feature) {}

    @Emit()
    savePolygon(name: string, cropTypeSelected: object | null, feature: google.maps.Data.Feature) {
        if(this.showCropType){
            this.modifyRanchPolygon(name, cropTypeSelected, feature)
        }
    }

    @Emit()
    cancelPolygon() {}

    updateCropTypeSelected(value) {
        this.cropTypeSelected = value;
    }
    updateCropTypeRV(value) {
        this.cropTypeRV = value;
    }

    mounted() {
        this.assignPropertiesData();
        if (this.editing && this.featureToEdit) {
            this.name = this.featureToEdit.getProperty('name') as string;
            this.setHarvestType(this.featureToEdit);
        }
    }

    assignPropertiesData(){
        this.cropTypeOptions = this.$_getInsuranceProperties['harvest_type'];
    }

    setHarvestType(featureToEdit: google.maps.Data.Feature){
        let harvestType = featureToEdit.getProperty('harvest_type') as string;
        if(harvestType == null){
            this.updateCropTypeSelected(null);
            return
        }
        let indexInCropTypes = !isNumber(harvestType) ? getIndexFromList(this.cropTypeOptions, 'value', harvestType) : getIndexFromList(this.cropTypeOptions, 'id', Number(harvestType));
        if(indexInCropTypes !== -1){
            this.updateCropTypeSelected(this.cropTypeOptions[indexInCropTypes])
        }
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }
}
